import React from "react";
import { Switch, Route } from "react-router-dom";

import List from './List';
import Form from './Form';

const Sellers = () =>
    (
        <Switch>
            <Route path='/sellers/create' component={Form} />
            <Route path='/sellers/:id/edit' exact component={Form} />
            <Route path='/sellers' component={List} />
        </Switch>
    );

export default Sellers;